<template>
  <nav class="footer-copyright">
    <div
      :class="{
        'checkout-footer':showImage,
        'completion-timer-space':addCompletionBtnSpace
      }"
    >
      <img
        src="https://cdn.karier.mu/kariermu/2023/assets/kariermu-logo.svg"
        alt="Karier.mu"
        class="sekolahmu-footer-logo"
        height="78"
        v-if="showImage"
      />
      <div class="container font-subtitle-3" id="copyright">
        <span class="footer-text">
          © {{ fullYear }} Karier.mu All Rights Reserved
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
import deviceDetector from 'mobile-device-detect'

export default {
  props: {
    showImage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isMobile: deviceDetector.isMobile
    }
  },
  computed: {
    fullYear () {
      var date = new Date()
      var year = date.getFullYear()
      return year
    },
    cdnEnv () {
      return process.env.VUE_APP_CDN_ENV
    },
    activityCompletionTimer () {
      return this.$store.state.activity.activityFocus?.completion_timer
    },
    hasCompletionTimer () {
      if (this.activityCompletionTimer >= 0) {
        return true
      } else if (this.activityCompletionTimer === -1) {
        return false
      }
    },
    currentRouteName () {
      return this.$route.name
    },
    addCompletionBtnSpace () {
      return this.isMobile && this.hasCompletionTimer && this.currentRouteName === 'activity-program'
    }
  }
}
</script>

<style scoped>
.footer-copyright {
  min-height: 104px;
  background: var(--color-neutral-300);
  text-align: center;
}

.checkout-footer {
  display: flex;
  align-items: center;
  padding: 18px 156px;
}

#copyright {
  color: rgba(0, 0, 0, 0.3);
  padding-top: 5px;
  padding-bottom: 5px
}

.completion-timer-space {
  padding-bottom: 60px;
}

.footer-text {
  color: var(--color-text-secondary);
}

@media (max-width: 770px) {
  .footer-copyright {
    font-size: 14px;
  }
}

@media screen and (max-width: 425px) {
  .checkout-footer {
    flex-direction: column;
    justify-content: center;
  }

  #copyright {
    display: flex;
    flex-direction: column;
  }

  .footer-text {
    font-size: 14px;
  }
}
</style>
